import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
import { fetchChildData, fetchParentData } from "./ParentHeader/FetchData";
import { Icon as IconifyIcon } from "@iconify/react";
export const getNavigationDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  parentHeader: [
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_footer_main_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_footer_main_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_footer_main_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_footer_main_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Key (EN)",
    //   fieldValue: "field_footer_main_key_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_main_key_en",
    //   formType: "input",
    //   label: "Key (EN)",
    //   placeholder: "Enter Key (EN)",
    //   validation: { required: "Key (EN) is required" },
    // },
    // {
    //   fieldName: "Key (MS)",
    //   fieldValue: "field_footer_main_key_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_main_key_ms",
    //   formType: "input",
    //   label: "Key (MS)",
    //   placeholder: "Enter Key (MS)",
    //   // validation: { required: "Key (MS) is required" },
    // },
    // {
    //   fieldName: "Key (ZH)",
    //   fieldValue: "field_footer_main_key_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_main_key_zh",
    //   formType: "input",
    //   label: "Key (ZH)",
    //   placeholder: "Enter Key (ZH)",
    //   // validation: { required: "Key (ZH) is required" },
    // },
    {
    fieldName: "Redirect URL",
    fieldValue: "field_footer_menu_redirect_url_e",
    className: "col-span-6",
    type: "text",
    name: "field_footer_menu_redirect_url_e",
    formType: "inputNotes",
    label: "Redirect URL",
    usedFileType: ".pdf",
    placeholder: "Enter Redirect URL",
    validation: { required: "Redirect URL is required" },
    note: 'Click the info icon to learn more before entering a value.',
    uploadTrigger: true
  },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "field_footer_menu_redirect_url_m",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_menu_redirect_url_m",
    //   formType: "inputNotes",
    //   usedFileType: ".pdf",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    //   // validation: { required: "Redirect URL (MS) is required" },
    //   note: 'Click the info icon to learn more before entering a value.',
    //   uploadTrigger: true
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "field_footer_menu_redirect_url_z",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_menu_redirect_url_z",
    //   formType: "inputNotes",
    //   usedFileType: ".pdf",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    //   // validation: { required: "Redirect URL (ZH) is required" },
    //   note: 'Click the info icon to learn more before entering a value.',
    //   uploadTrigger: true
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Is published",
    },
  ], 
  webAppFooter: [
    {
      fieldName: "Copyright Text (EN)",
      fieldValue: "field_copyright_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_en",
      formType: "input",
      label: "Copyright Text (EN)",
      placeholder: "Enter Copyright Text (EN)",
      validation: { required: "Copyright Text (EN) is required" },
    },
    {
      fieldName: "Copyright Text (MS)",
      fieldValue: "field_copyright_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_ms",
      formType: "input",
      label: "Copyright Text (MS)",
      placeholder: "Enter Copyright Text (MS)",
      // validation: { required: "Copyright Text (MS) is required" },
    },
    {
      fieldName: "Copyright Text (ZH)",
      fieldValue: "field_copyright_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_copyright_text_zh",
      formType: "input",
      label: "Copyright Text (ZH)",
      placeholder: "Enter Copyright Text (ZH)",
      // validation: { required: "Copyright Text (ZH) is required" },
    },
    {
      fieldName: "Register Number Text (EN)",
      fieldValue: "field_registration_number_txt_en",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_en",
      formType: "input",
      label: "Register Number Text (EN)",
      placeholder: "Enter Register Number Text (EN)",
      validation: { required: "Register Number Text (EN) is required" },
    },
    {
      fieldName: "Register Number Text (MS)",
      fieldValue: "field_registration_number_txt_ms",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_ms",
      formType: "input",
      label: "Register Number Text (MS)",
      placeholder: "Enter Register Number Text (MS)",
      // validation: { required: "Register Number Text (MS) is required" },
    },
    {
      fieldName: "Register Number Text (ZH)",
      fieldValue: "field_registration_number_txt_zh",
      className: "col-span-6",
      type: "text",
      name: "field_registration_number_txt_zh",
      formType: "input",
      label: "Register Number Text (ZH)",
      placeholder: "Enter Register Number Text (ZH)",
      // validation: { required: "Register Number Text (ZH) is required" },
    },
    {
      fieldName: "Mobile App Text (EN)",
      fieldValue: "field_mobile_app_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_en",
      formType: "input",
      label: "Mobile App Text (EN)",
      placeholder: "Enter Mobile App Text (EN)",
      validation: { required: "Mobile App Text (EN) is required" },
    },
    {
      fieldName: "Mobile App Text (MS)",
      fieldValue: "field_mobile_app_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_ms",
      formType: "input",
      label: "Mobile App Text (MS)",
      placeholder: "Enter Mobile App Text (MS)",
      // validation: { required: "Mobile App Text (MS) is required" },
    },
    {
      fieldName: "Mobile App Text (ZH)",
      fieldValue: "field_mobile_app_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_mobile_app_text_zh",
      formType: "input",
      label: "Mobile App Text (ZH)",
      placeholder: "Enter Mobile App Text (ZH)",
      // validation: { required: "Mobile App Text (ZH) is required" },
    },
    {
      fieldName: "Terms of Use Text (EN)",
      fieldValue: "field_term_of_use_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_en",
      formType: "input",
      label: "Terms of Use Text (EN)",
      placeholder: "Enter Terms of Use Text (EN)",
      validation: { required: "Terms of Use Text (EN) is required" },
    },
    {
      fieldName: "Terms of Use Text (MS)",
      fieldValue: "field_term_of_use_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_ms",
      formType: "input",
      label: "Terms of Use Text (MS)",
      placeholder: "Enter Terms of Use Text (MS)",
      // validation: { required: "Terms of Use Text (MS) is required" },
    },
    {
      fieldName: "Terms of Use Text (ZH)",
      fieldValue: "field_term_of_use_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_term_of_use_text_zh",
      formType: "input",
      label: "Terms of Use Text (ZH)",
      placeholder: "Enter Terms of Use Text (ZH)",
      // validation: { required: "Terms of Use Text (ZH) is required" },
    },
    {
      fieldName: "Terms of Use Link",
      fieldValue: "termsOfUseLink",
      className: "col-span-6",
      type: "text",
      name: "termsOfUseLink",
      formType: "input",
      label: "Terms of Use Link",
      placeholder: "Enter Terms of Use Link",
      validation: { required: "Terms of Use Link is required" },
    },

    {
      fieldName: "Privacy Policy Text (EN)",
      fieldValue: "field_privacy_policy_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_en",
      formType: "input",
      label: "Privacy Policy Text (EN)",
      placeholder: "Enter Privacy Policy Text (EN)",
      validation: { required: "Privacy Policy Text (EN) is required" },
    },
    {
      fieldName: "Privacy Policy Text (MS)",
      fieldValue: "field_privacy_policy_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_ms",
      formType: "input",
      label: "Privacy Policy Text (MS)",
      placeholder: "Enter Privacy Policy Text (MS)",
      // validation: { required: "Privacy Policy Text (MS) is required" },
    },
    {
      fieldName: "Privacy Policy Text (ZH)",
      fieldValue: "field_privacy_policy_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_zh",
      formType: "input",
      label: "Privacy Policy Text (ZH)",
      placeholder: "Enter Privacy Policy Text (ZH)",
      // validation: { required: "Privacy Policy Text (ZH) is required" },
    },
    {
      fieldName: "Privacy Policy Link",
      fieldValue: "privacyPolicyLink",
      className: "col-span-6",
      type: "text",
      name: "privacyPolicyLink",
      formType: "input",
      label: "Privacy Policy Link",
      placeholder: "Enter Privacy Policy Link",
      validation: { required: "Privacy Policy Link is required" },
    },
    {
      fieldName: "Play Store Image",
      fieldValue: "playStoreImage",
      className: "col-span-6",
      type: "image",
      usedFileType:'image/*',
      name: "playStoreImage",
      formType: "file",
      label: "Play Store Image",
      placeholder: "Enter Play Store Image",
      validation: { required: "Play Store Image is required" },
    },
    {
      fieldName: "Play Store Link",
      fieldValue: "privacyPolicyLink",
      className: "col-span-6",
      type: "text",
      name: "privacyPolicyLink",
      formType: "input",
      label: "Play Store Link",
      placeholder: "Enter Play Store Link",
      validation: { required: "Play Store Link is required" },
    },
    {
      fieldName: "App Store Image",
      fieldValue: "appStoreImage",
      className: "col-span-6",
      type: "image",
      usedFileType:'image/*',
      name: "appStoreImage",
      formType: "file",
      label: "App Store Image",
      placeholder: "Enter App Store Image",
      validation: { required: "App Store Image is required" },
    },
    {
      fieldName: "App Store Link",
      fieldValue: "appStoreLink",
      className: "col-span-6",
      type: "text",
      name: "appStoreLink",
      formType: "input",
      label: "App Store Link",
      placeholder: "Enter App Store Link",
      validation: { required: "App Store Link is required" },
    },
  ],
  childHeader: [
    {
      fieldName: "Parent Header",
      fieldValue: "parent_id",
      className: "col-span-6",
      type: "text",
      name: "parent_id",
      formType: "select",
      loadOptions: fetchParentData,
      label: "Parent Header",
      placeholder: "Enter Parent Header",
      validation: { required: "Parent Header is required" },
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_footer_child_name_ms",
      className: "col-span-6",
      type: "text",
      name: "field_footer_child_name_ms",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_footer_child_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_footer_child_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Key (EN)",
    //   fieldValue: "field_footer_child_key_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_child_key_en",
    //   formType: "input",
    //   label: "Key (EN)",
    //   placeholder: "Enter Key (EN)",
    //   validation: { required: "Key (EN) is required" },
    // },
    // {
    //   fieldName: "Key (MS)",
    //   fieldValue: "field_footer_child_key_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_child_key_ms",
    //   formType: "input",
    //   label: "Key (MS)",
    //   placeholder: "Enter Key (MS)",
    //   // validation: { required: "Key (MS) is required" },
    // },
    // {
    //   fieldName: "Key (ZH)",
    //   fieldValue: "field_footer_child_key_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_child_key_zh",
    //   formType: "input",
    //   label: "Key (ZH)",
    //   placeholder: "Enter Key (ZH)",
    //   // validation: { required: "Key (ZH) is required" },
    // },
    {
      fieldName: "Redirect URL",
      fieldValue: "field_footer_child_redirect_url",
      className: "col-span-6",
      type: "text",
      name: "field_footer_child_redirect_url",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "field_footer_child_redirect_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_child_redirect_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    //   // validation: { required: "Redirect URL (MS) is required" },
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "field_footer_child_redirect_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_child_redirect_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    //   // validation: { required: "Redirect URL (ZH) is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Is published",
    },
  ],
  grandChildHeader: [
    {
      fieldName: "Child Header",
      fieldValue: "child_heading_id",
      className: "col-span-6",
      type: "text",
      name: "child_heading_id",
      formType: "select",
      loadOptions: fetchChildData,
      label: "Child Header",
      placeholder: "Enter Child Header",
      validation: { required: "Child Header is required" },
    },
    {
      fieldName: "Name (EN)",
      fieldValue: "name",
      className: "col-span-6",
      type: "text",
      name: "name",
      formType: "input",
      label: "Name (EN)",
      placeholder: "Enter Name (EN)",
      validation: { required: "Name (EN) is required" },
    },
    {
      fieldName: "Name (MS)",
      fieldValue: "field_footer_grand_child_name",
      className: "col-span-6",
      type: "text",
      name: "field_footer_grand_child_name",
      formType: "input",
      label: "Name (MS)",
      placeholder: "Enter Name (MS)",
      // validation: { required: "Name (MS) is required" },
    },
    {
      fieldName: "Name (ZH)",
      fieldValue: "field_footer_grand_child_name_zh",
      className: "col-span-6",
      type: "text",
      name: "field_footer_grand_child_name_zh",
      formType: "input",
      label: "Name (ZH)",
      placeholder: "Enter Name (ZH)",
      // validation: { required: "Name (ZH) is required" },
    },
    // {
    //   fieldName: "Key (EN)",
    //   fieldValue: "field_footer_grand_child_key_en",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_grand_child_key_en",
    //   formType: "input",
    //   label: "Key (EN)",
    //   placeholder: "Enter Key (EN)",
    //   validation: { required: "Key (EN) is required" },
    // },
    // {
    //   fieldName: "Key (MS)",
    //   fieldValue: "field_footer_grand_child_key_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_grand_child_key_ms",
    //   formType: "input",
    //   label: "Key (MS)",
    //   placeholder: "Enter Key (MS)",
    //   // validation: { required: "Key (MS) is required" },
    // },
    // {
    //   fieldName: "Key (ZH)",
    //   fieldValue: "field_footer_grand_child_key_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_grand_child_key_zh",
    //   formType: "input",
    //   label: "Key (ZH)",
    //   placeholder: "Enter Key (ZH)",
    //   // validation: { required: "Key (ZH) is required" },
    // },
    {
      fieldName: "Redirect URL",
      fieldValue: "field_footer_grand_redirect_en",
      className: "col-span-6",
      type: "text",
      name: "field_footer_grand_redirect_en",
      formType: "inputNotes",
      label: "Redirect URL",
      placeholder: "Enter Redirect URL",
      validation: { required: "Redirect URL is required" },
      note: 'Click the info icon to learn more before entering a value.',
      uploadTrigger: true
    },
    // {
    //   fieldName: "Redirect URL (MS)",
    //   fieldValue: "field_footer_grand_redirect_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_grand_redirect_ms",
    //   formType: "input",
    //   label: "Redirect URL (MS)",
    //   placeholder: "Enter Redirect URL (MS)",
    //   // validation: { required: "Redirect URL (MS) is required" },
    // },
    // {
    //   fieldName: "Redirect URL (ZH)",
    //   fieldValue: "field_footer_grand_redirect_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_footer_grand_redirect_zh",
    //   formType: "input",
    //   label: "Redirect URL (ZH)",
    //   placeholder: "Enter Redirect URL (ZH)",
    //   // validation: { required: "Redirect URL (ZH) is required" },
    // },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Is published",
    },
  ],
};
